import React from "react";
import styled from "styled-components";
import {
  FacebookShareButton,
  FacebookShareCount,
  HatenaShareButton,
  HatenaShareCount,
  LineShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  PocketShareButton,
  TumblrShareButton,
  EmailShareButton,
  WhatsappShareButton,
  PinterestShareButton,
  FacebookIcon,
  HatenaIcon,
  LineIcon,
  TwitterIcon,
  LinkedinIcon,
  PocketIcon,
  TumblrIcon,
  EmailIcon,
  PinterestIcon,
  WhatsappIcon
} from "react-share";

type Props = {
  url:string
  title:string
}

const Wrapper = styled.div`
  button{ width: 10%; padding:3px 0 !important;  }
  .share-btn-facebook{ background-color:#3b5998 !important; }
  .share-btn-twitter{ background-color:#02aced !important; }
  .share-btn-line{ background-color:#00b800 !important; }
  .share-btn-hatena{ background-color:#009ad9 !important; }
  .share-btn-linkedin{ background-color:#007fb1 !important; }
  .share-btn-pocket{ background-color:#ef3f57 !important; }
  .share-btn-tumblr{ background-color:#2b4762 !important; }
  .share-btn-email{ background-color:#7f7f7f !important; }
  .share-btn-pinterest{ background-color:#cb2129 !important; }
  .share-btn-whatsapp{ background-color:#24d366 !important; }
`

const ShareButtons = (props:Props) => {
  return (
    <Wrapper className="share-buttons">
      <FacebookShareButton url={props.url} quote={props.title} className="share-btn-facebook">
        <FacebookIcon size={32} />
        {/* <FacebookShareCount url={props.url} className="share-count">
          {count => count}
        </FacebookShareCount> */}
      </FacebookShareButton>
      <TwitterShareButton url={props.url} title={props.title} className="share-btn-twitter">
        <TwitterIcon size={32} />
      </TwitterShareButton>
      <LineShareButton url={props.url} title={props.title} className="share-btn-line">
        <LineIcon size={32} />
      </LineShareButton>
      <HatenaShareButton url={props.url} title={props.title} windowWidth={660} windowHeight={460} className="share-btn-hatena">
        <HatenaIcon size={32} />
        {/* <HatenaShareCount url={props.url}>
          {shareCount => <div>num:{shareCount}</div>}
        </HatenaShareCount> */}
      </HatenaShareButton>
      <LinkedinShareButton url={props.url} title={props.title} className="share-btn-linkedin">
        <LinkedinIcon size={32} />
      </LinkedinShareButton>
      <PocketShareButton url={props.url} title={props.title} className="share-btn-pocket">
        <PocketIcon size={32} />
      </PocketShareButton>
      <TumblrShareButton url={props.url} title={props.title} className="share-btn-tumblr">
        <TumblrIcon size={32} />
      </TumblrShareButton>
      <EmailShareButton url={props.url} title={props.title} className="share-btn-email">
        <EmailIcon size={32} />
      </EmailShareButton>
      <PinterestShareButton url={props.url} media={props.url} description={props.title} className="share-btn-pinterest">
        <PinterestIcon size={32} />
      </PinterestShareButton>
      <WhatsappShareButton url={props.url} title={props.title} className="share-btn-whatsapp">
        <WhatsappIcon size={32} />
      </WhatsappShareButton>
    </Wrapper>
  )
}

export default ShareButtons;